export const LOAD_CUSTOMERDOCUMENTS_SUCCESS = "LOAD_CUSTOMERDOCUMENTS_SUCCESS";

export const CREATE_CUSTOMERDOCUMENT_SUCCESS = "CREATE_CUSTOMERDOCUMENT_SUCCESS";

export const SAVE_CUSTOMERDOCUMENT_SUCCESS = "SAVE_CUSTOMERDOCUMENT_SUCCESS";

export const DELETE_CUSTOMERDOCUMENT_SUCCESS = "DELETE_CUSTOMERDOCUMENT_SUCCESS";

export const LOAD_CUSTOMERDOCUMENT_DETAIL_SUCCESS = "LOAD_CUSTOMERDOCUMENT_DETAIL_SUCCESS";

export const CREATE_CUSTOMERDOCUMENT = "CREATE_CUSTOMERDOCUMENT";
export const SAVE_CUSTOMERDOCUMENT = "SAVE_CUSTOMERDOCUMENT";
